module.exports = __webpack_public_path__ + "img/icon_detail_msg_white.d8f686fb.png";